
















import Vue from "vue";

export default Vue.component('RowItemSummary', {
  props: {
    firstRowLeft: {
      type: [String, Number]
    },
    firstRowRight: {
      type: [String, Number]
    },
    secondRowLeft: {
      type: [String, Number]
    },
    secondRowRight: {
      type: [String, Number]
    },
    thirdRowLeft: {
      type: [String, Number]
    },
    thirdRowRight: {
      type: [String, Number]
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/RowItemSummary.vue